'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

export type FooterMode = 'scroll' | 'toggle' | 'hidden';

type FooterContextType = {
  footerMode: FooterMode;
  setFooterMode: (mode: FooterMode) => void;
  isFooterOpen: boolean;
  setIsFooterOpen: (open: boolean) => void;
  toggleFooter: () => void;
};

const FooterContext = createContext<FooterContextType | undefined>(undefined);

export const FooterProvider = ({ children }: { children: ReactNode }) => {
  const [footerMode, setFooterMode] = useState<FooterMode>('scroll');
  const [isFooterOpen, setIsFooterOpen] = useState(false);

  const toggleFooter = () => setIsFooterOpen((prev) => !prev);

  return (
    <FooterContext.Provider value={{ footerMode, setFooterMode, isFooterOpen, setIsFooterOpen, toggleFooter }}>
      {children}
    </FooterContext.Provider>
  );
};

export const useFooter = () => {
  const context = useContext(FooterContext);
  if (context === undefined) {
    throw new Error('useFooter must be used within a FooterProvider');
  }
  return context;
};
